<template>
    <li class="md:flex-1">
        <a
            v-if="status === StepStatus.Complete"
            class="group flex flex-col border-l-4 border-blue-600 py-2 pl-4 hover:border-blue-700 md:border-t-4 md:border-l-0 md:pt-4 md:pb-0 md:pl-0"
            :data-spec-value="status"
        >
            <span
                v-if="label"
                class="text-left text-sm font-medium"
                >{{ label }}</span
            >
        </a>
        <a
            v-else-if="status === StepStatus.Current"
            class="flex flex-col border-l-4 border-blue-600 py-2 pl-4 text-left md:border-t-4 md:border-l-0 md:pt-4 md:pb-0 md:pl-0"
            aria-current="step"
            :data-spec-value="status"
        >
            <span
                v-if="label"
                class="text-sm font-medium"
                >{{ label }}</span
            >
        </a>
        <a
            v-else
            class="group flex flex-col border-l-4 border-gray-200 py-2 pl-4 text-left hover:border-gray-300 md:border-t-4 md:border-l-0 md:pt-4 md:pb-0 md:pl-0"
            :data-spec-value="status"
        >
            <span
                v-if="label"
                class="text-sm font-medium"
                >{{ label }}</span
            >
        </a>
    </li>
</template>

<script setup lang="ts">
import { withDefaults, defineProps } from 'vue';
import { StepStatus } from '@/types';

interface Props {
    label?: string;
    status?: StepStatus;
}

withDefaults(defineProps<Props>(), {
    label: undefined,
    status: undefined,
});
</script>
